import React from 'react';

const SvgWorkflow = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M6 3C4.355 3 3 4.355 3 6c0 1.293.843 2.395 2 2.813V13h2V8.812C8.157 8.396 9 7.293 9 6c0-1.645-1.355-3-3-3zm12 0a3 3 0 00-2.824 2H11v2h4.174a3 3 0 004.947 1.121A3 3 0 0018 3zM6 5c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1zm11 6v4l-3 3 4 4 4-4-3-3v-4h-2zM3 15v6h6v-6H3z" />
  </svg>
);

export default SvgWorkflow;
